import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const InfiniteScroll = ({ limit, children, totalData, getData, setIsAtTop, nextCall, setNextCall, skipValue, setSkipValue }) => {
  const [loadMoreData, setLoadMoreData] = useState(false);
  const [currentScrollTopPosition, setCurrentScrollTopPosition] = useState(0);
  const tableRef = React.createRef();

  const prevCallback = async (newOffset) => {
    if (newOffset >= 0 && nextCall) {
      setLoadMoreData(true);
      setSkipValue(newOffset);
      if (skipValue === 0) {
        setNextCall(false);
      }
      await getData(newOffset, limit, true);
      setLoadMoreData(false);
    }
    else
      setNextCall(false);
  };

  const nextCallback = async (newOffset) => {
    setNextCall(true);
    setLoadMoreData(true);
    setSkipValue(newOffset);
    await getData(newOffset, limit, true);
    setLoadMoreData(false);
  };

  const handleScroll = async (target) => {
    if (totalData > 0) {
      const table = tableRef.current;
      if (table && !loadMoreData) {
        const scrollTop = Math.round(target.scrollTop);
        const clientHeight = Math.round(target.clientHeight);
        const scrollHeight = Math.round(target.scrollHeight);
        const isUp = scrollTop < currentScrollTopPosition;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

        if (scrollTop === 0 && isUp) {
          setIsAtTop(true);
          await prevCallback(skipValue - limit);
          if(skipValue != 0)
          {
            const scrollPos = limit - 20;
            table.scrollTo(0, scrollPos * 2 + clientHeight);
          }
        } else if (isAtBottom && !isUp) {
          const assignmentCount = totalData / (skipValue + limit);
          if (assignmentCount > 1) {
            await nextCallback(skipValue + limit);
            const scrollPos = limit - 20;
            table.scrollTo(0, scrollPos * 2 + clientHeight);
          }
        }
        setCurrentScrollTopPosition(scrollTop);
      }
    }
  };

  useEffect(() => {
    if (nextCall && loadMoreData)
      setIsAtTop(true);
    else
      setIsAtTop(false);
  }, [nextCall, loadMoreData]);

  return (
    <div className='assignments-scroll-bar custom-table table-responsive' ref={tableRef} onScroll={(e) => handleScroll(e.target)}>
      {children}
      {loadMoreData && (
        <div className='scroll-spinner mt-3 d-flex align-item-center justify-content-center'>
          <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'>Load More</span>
        </div>
      )}
    </div>
  );
};

InfiniteScroll.propTypes = {
  limit: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  totalData: PropTypes.number.isRequired,
  getData: PropTypes.func.isRequired,
  setIsAtTop: PropTypes.func.isRequired,
  nextCall: PropTypes.bool.isRequired,
  setNextCall: PropTypes.func.isRequired,
  skipValue: PropTypes.number.isRequired,
  setSkipValue: PropTypes.number.isRequired
};

export default InfiniteScroll;
